module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/sg/sg_b_blanco-637aa113b1bf8f32435c73f3fa597f59.svg";